const SectionTitle = ({ title }) => {
    return (
        <div className="progressmatify-section">
            <h2 className="progressmatify-section-title">{title}</h2>
        </div>
    );
};

export default SectionTitle;
